export default __webpack_public_path__ + "static/media/logo.cb7e4531.svg";